module.exports = __webpack_public_path__ + "static/media/measures1.915ea4fe.png";